import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      data-testid="impressum-page"
      className="min-h-screen bg-[#FAFAF7] text-[#1A1A1F]"
    >
      {/* Slim Header */}
      <header className="border-b border-[#1A1A1F]/[0.08] bg-[#FAFAF7]/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="impressum-logo-link">
            <Logo height={26} />
          </Link>
          <Link
            to="/"
            data-testid="impressum-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#5A5F66] hover:text-[#1A1A1F] transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28">
        <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
          Rechtliches
        </div>
        <h1
          data-testid="impressum-headline"
          className="text-5xl sm:text-6xl font-medium tracking-tight leading-[1.05]"
        >
          <span className="text-gradient-dark">Impressum</span>
        </h1>

        <div className="mt-12 space-y-10 text-[#1A1A1F]/85 leading-relaxed">
          <section data-testid="impressum-section-tmg">
            <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-base text-[#1A1A1F]/85">
              Pflegeheld Handels GmbH
              <br />
              Bahnhofstraße 71
              <br />
              31515 Wunstorf
              <br />
              Deutschland
            </p>
            <p className="mt-4 text-base text-[#1A1A1F]/85">
              Vertreten durch den Geschäftsführer:
              <br />
              Jan Brinkmann
            </p>
          </section>

          <section data-testid="impressum-section-kontakt">
            <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">
              Kontakt
            </h2>
            <p className="text-base">
              Telefon:{" "}
              <a
                href="tel:+4917670157687"
                className="text-[#3FA66D] hover:underline"
              >
                0176 70157687
              </a>
              <br />
              E-Mail:{" "}
              <a
                href="mailto:info@pflege-box-gratis.de"
                className="text-[#3FA66D] hover:underline break-all"
              >
                info@pflege-box-gratis.de
              </a>
            </p>
          </section>

          <section data-testid="impressum-section-hrb">
            <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">
              Handelsregister
            </h2>
            <p className="text-base">
              Registergericht: Amtsgericht Hannover
              <br />
              Registernummer: HRB 225743
            </p>
          </section>

          <section data-testid="impressum-section-steuer">
            <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">
              Umsatzsteuer / Steuernummer
            </h2>
            <p className="text-base">Steuernummer: 34/204/19726</p>
          </section>

          <section data-testid="impressum-section-verantwortlich">
            <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p className="text-base">
              Jan Brinkmann
              <br />
              Bahnhofstraße 71
              <br />
              31515 Wunstorf
              <br />
              Deutschland
            </p>
          </section>

          <section
            data-testid="impressum-section-eu"
            className="rounded-2xl glass-mint p-6 sm:p-8"
          >
            <h2 className="text-xl font-medium text-[#1A1A1F] mb-3">
              EU-Streitschlichtung
            </h2>
            <p className="text-sm text-[#1A1A1F]/80">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#3FA66D] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind
              nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1A1A1F]/[0.08] text-xs text-[#5A5F66]">
          © {new Date().getFullYear()} pflege-box-gratis.de · Alle Rechte
          vorbehalten
        </div>
      </main>
    </div>
  );
};

export default Impressum;
